import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';

export const MarketplaceDashboardMenuItem = () => (
    <LeftMenuItem
        icon="pe-7s-plugin"
        label="Marketplace Dashboard"
        to="/opportunities?tab=dashboard"
        flagCode={NotificationFlagsCategories.MpCode}
        trackingAction="Marketplace Opportunities"
        gtmCategory="Marketplace Opportunities"
    />
);
